import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Spinner = ({ isLoading, message }) => {
  const theme = useTheme();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      open={isLoading}
    >
      <div style={{ textAlign: 'center' }}>
        <CircularProgress color="inherit" />
        {message && (
          <Typography variant="h6" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </div>
    </Backdrop>
  );
};

export default Spinner;